import { TableProps } from 'antd/es/table';

import { Status } from '@Components/Base';

export const mapColumns: TableProps['columns'] = [
  {
    title: 'REQUEST NO.',
    dataIndex: 'requestNo',
    key: 'requestId',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'REQUEST CATEGORY',
    dataIndex: 'reqType',
    key: 'leaveTypeID',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'CREATED DATE',
    dataIndex: 'createdDate',
    key: 'createdDate',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'DEPT / PROJECT',
    dataIndex: 'projDept',
    key: 'deptProjID',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'REASON / LOCATION',
    dataIndex: 'reason',
    key: 'totDays',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'EMP NAME',
    dataIndex: 'empName',
    key: 'empName',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'APPROVER NAME',
    dataIndex: 'approverName',
    key: 'approverName',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'STATUS',
    dataIndex: 'status',
    key: 'reqStatusId',
    sorter: true,
    render: (text) => <Status text={text} />,
  },
];
